import { Button, Paper, TableBody, TableCell, TextField } from '@mui/material';
import { Box, Card, CardContent, Divider, IconButton, Table, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';

import { Label } from '../../Label';
import React from 'react';
import { Row } from '../../../utilities/constants';

const InvoiceSummary = (props) => {
  const { invoice } = props;

  const getPrice = (amount) => {
    return (amount / 100).toFixed(2);
  };

  return (
    <>
      <Row style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}>
        <div className="w-full max-w-[752px]">
          {/* ORDER SUMMARY CARD */}
          <Card
            elevation={0}
            style={{
              border: '1px solid #A2A2A2',
              borderRadius: 16,
            }}
          >
            <CardContent style={{ padding: 16 }}>
              {/* Title */}
              <Typography
                style={{ fontWeight: 700, fontSize: 18, display: 'flex' }}
              >
                Invoice Summary
              </Typography>

              <Divider style={{ marginTop: 12, marginBottom: 12 }} />

              <Box>
                {/* Top row: Package name */}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography
                    style={{
                      fontWeight: 700,
                      fontSize: 16,
                      color: '#6A0DAD',
                    }}
                  >
                    Invoice no.
                  </Typography>
                  <Typography style={{ fontWeight: 700 }}>
                    {invoice?.number}
                  </Typography>
                </Box>

                {/* Divider between products */}
                <Divider style={{ marginTop: 12, marginBottom: 12 }} />
              </Box>

              {/* Totals */}
              <Box>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography style={{ fontWeight: 800, fontSize: 16 }}>Total</Typography>
                  <Typography style={{ fontWeight: 800, fontSize: 16 }}>
                    ${getPrice(invoice?.ammountRemaining)}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

        </div>
      </Row>
    </>
  );
};

export default InvoiceSummary;
